import React from 'react';
import { Header } from './Header';
import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

export const PublicLayout = () => {
    const { auth } = useAuth();

    console.log("Estado de auth en PublicLayout:", auth);

    return (
        <>
            <Header />
            <section id="content" className="layout-content">
                {!auth || !auth.id ? ( // Validamos que auth exista y tenga un id
                    <Outlet /> // Renderizamos el contenido público
                ) : (
                    <Navigate to="/app/inicio" replace /> // Redirigimos a la zona privada si está autenticado
                )}
            </section>
        </>
    );
};
